import { render, staticRenderFns } from "./ReChannelEdit.vue?vue&type=template&id=7b4d3226&scoped=true"
import script from "./ReChannelEdit.vue?vue&type=script&lang=js"
export * from "./ReChannelEdit.vue?vue&type=script&lang=js"
import style0 from "./ReChannelEdit.vue?vue&type=style&index=0&id=7b4d3226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d3226",
  null
  
)

export default component.exports